import { Actions } from "../Actions/Actions";

const initialState = {
  betslips: [],
  selectedBetslipBtn: []
};


export default function selectedBetslipReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case Actions.SELECTED_BETSLIP:
      return {
        ...state,
        betslips: [...state.betslips, action.data],
        selectedBetslipBtn: [...state.selectedBetslipBtn, action.selectedBtn]
      };
      
    case Actions.REMOVE_SELECTED_BETSLIP:
      let newslipArray = [...state.betslips];
      newslipArray.splice(action.removeEleIndex, 1);

      let newSelectedBetslipBtnArray = [...state.selectedBetslipBtn];
      newSelectedBetslipBtnArray.splice(action.removeEleIndex, 1);
      return {
        ...state,
        betslips: newslipArray,
        selectedBetslipBtn: newSelectedBetslipBtnArray
      };
    case Actions.REMOVE_ALL_BETSLIP:
      return {
        ...state,
        betslips: [],
        selectedBetslipBtn: []
      };
    default:
      return state;
  }
}
